import { render, staticRenderFns } from "./AccessProfileForm.vue?vue&type=template&id=561be932&scoped=true&"
import script from "./AccessProfileForm.vue?vue&type=script&lang=js&"
export * from "./AccessProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./AccessProfileForm.vue?vue&type=style&index=0&id=561be932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561be932",
  null
  
)

export default component.exports